import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { CheckoutProgressMobileTopComponent } from '@spartacus/checkout/base/components'

@Component({
    selector: 'eb-checkout-progress-mobile-top',
    templateUrl: './eb-checkout-progress-mobile-top.component.html',
    styleUrls: ['./eb-checkout-progress-mobile-top.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class EbCheckoutProgressMobileTopComponent extends CheckoutProgressMobileTopComponent {
  @Output() changeStep = new EventEmitter<number>()

  getTabIndex(stepIndex: number): number {
    return !this.isActive(stepIndex) && !this.isDisabled(stepIndex) ? 0 : -1
  }

  isActive(index: number): boolean {
    return index <= this.activeStepIndex
  }

  isDisabled(index: number): boolean {
    return index > this.activeStepIndex
  }
}
